module.exports = __webpack_public_path__ + "img/introduction_banner.6fbcc3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/introduction_banner.png
// module id = 947
// module chunks = 1